import { createContext, useContext } from 'react';

export const ShareAsideContext = createContext<string>('');

export const useShareAsideRootId = () => {
  return useContext(ShareAsideContext);
};
